module.exports = __webpack_public_path__ + "img/challenge-5-nl.ddd592d7.png";